'use client';

import React, { useState } from 'react';
import LocalButton from './LocalButton';
import Navigation from '@/src/app/_components/Navigation';
import Logo from '@/src/app/_components/Logo';

function Header({ locale }: { locale: string }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const isArabic = locale === 'ar';

  return (
    <>
      {/* Laptop Header (1440px) */}
      <header
        id="Home"
        className="fixed top-0 z-50 hidden w-full bg-white/50 py-8 backdrop-blur-2xl lg:block">
        <div className="mx-auto hidden h-full w-full max-w-[1440px] items-center justify-between px-5 lg:flex lg:px-10">
          <Logo className="h-[45px] w-[76px]" />
          <Navigation />
          <LocalButton />
        </div>
      </header>

      {/* Mobile/Tablet Header (<1024px) */}
      <header
        id="Home"
        className="h-[10vh] max-w-screen rounded-xl bg-white px-3 text-sm tracking-tight text-black uppercase sm:px-4 sm:text-base lg:hidden lg:py-2">
        <div className="flex h-full items-center justify-between">
          <Logo size={90} />
          <button
            type="button"
            onClick={toggleSidebar}
            className="cursor-pointer p-2 text-[#122C5F] transition-transform duration-300 ease-in-out hover:scale-110 hover:text-[#1E40AF] focus:outline-none"
            aria-label="Toggle sidebar">
            <svg
              className="h-6 w-6 transition-colors duration-300 ease-in-out sm:h-8 sm:w-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              />
            </svg>
          </button>
        </div>
      </header>

      {/* Sidebar for Mobile/Tablet */}
      <div
        className={`fixed top-0 ${
          isArabic ? 'left-0' : 'right-0'
        } z-50 h-full w-64 transform bg-white text-black transition-transform duration-300 sm:w-80 ${
          isSidebarOpen ? 'translate-x-0' : isArabic ? '-translate-x-full' : 'translate-x-full'
        } lg:hidden`}>
        <div className="flex h-full flex-col p-4 sm:p-6">
          <button
            type="button"
            onClick={toggleSidebar}
            className="cursor-pointer self-end p-2 text-[#122C5F] transition-transform duration-300 ease-in-out hover:rotate-90 hover:text-[#B91C1C] focus:outline-none"
            aria-label="Close sidebar">
            <svg
              className="h-6 w-6 transition-colors duration-300 ease-in-out sm:h-8 sm:w-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <div className="mt-4 flex flex-col gap-6">
            <Navigation />
            <div className="flex flex-col gap-4">
              {/* <LoginButton /> */}
              <LocalButton />
            </div>
          </div>
        </div>
      </div>

      {/* Overlay when sidebar is open */}
      {isSidebarOpen && (
        <div className="fixed inset-0 z-40 bg-black/30 lg:hidden" onClick={toggleSidebar} />
      )}
    </>
  );
}

export default Header;
